import { Box, Typography } from '@mui/material';
import { getSelectorAttribute } from '@vy/app-selectors';
import { FC } from 'react';
import type { MetricBoxProps } from '../types';
import { metricBoxStyles } from './styles';

export const MetricBox: FC<MetricBoxProps> = ({ label, value, selector }) => (
  <Box sx={metricBoxStyles.container} {...(selector ? getSelectorAttribute(selector) : {})}>
    <Typography variant="body2" sx={metricBoxStyles.label}>
      {label}
    </Typography>
    <Typography variant="h6" sx={metricBoxStyles.value}>
      {value}
    </Typography>
  </Box>
);
